<template>
  <div class="content">
    <div>
      <a-button @click="saveSettings(2)">保存设置</a-button>
    </div>
    <div>
      <a-form-model :model="defaultSettings" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="系统名称">
          <a-input v-model="defaultSettings.title" />
        </a-form-model-item>
        <a-form-model-item label="系统logo">
          <file-upload v-model="defaultSettings.logo" :limit="1"></file-upload>
        </a-form-model-item>
        <a-form-model-item label="大屏名称">
          <a-input v-model="defaultSettings.dp" />
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>
<script>
import defaultSettings from '@/config/defaultSettings'
export default {
  name: 'setting',
  data() {
    return {
      activeMenu: 'config',
      settings: {
        title: '若依管理系统',
        version: '4.7.0',
        sidebarTheme: 'dark',
        showSettings: true,
        tagsView: true,
        fixedHeader: true,
        sidebarLogo: true,
        errorLog: true,
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      isEdit: false,
      defaultSettings: {
        title: '',
        version: '',
        sidebarTheme: '',
        showSettings: true,
        tagsView: true,
        fixedHeader: true,
        sidebarLogo: true,
        errorLog: true,
      },
      loading: true,
      loadingMore: false,
      showLoadingMore: true,
      data: [],
    }
  },
  created() {
    this.defaultSettings = { ...defaultSettings }
    console.log('defaultSettings:', defaultSettings)
  },
  computed: {
    settingsCode() {
      return `// 系统默认设置
export default {
  title: '${this.settings.title}',           // 系统标题
  version: '${this.settings.version}',       // 系统版本
  sidebarTheme: '${this.settings.sidebarTheme}', // 侧边栏主题 dark/light
  showSettings: ${this.settings.showSettings},   // 是否显示设置面板
  tagsView: ${this.settings.tagsView},       // 是否显示标签页
  fixedHeader: ${this.settings.fixedHeader}, // 是否固定头部
  sidebarLogo: ${this.settings.sidebarLogo}, // 是否显示侧边栏Logo
  errorLog: ${this.settings.errorLog}        // 是否收集错误日志
}`
    },
  },
  methods: {
    saveSettings(type) {
      // 在实际项目中，这里会调用API保存设置或直接修改defaultSettings.js文件
    },
    resetSettings() {
      this.settings = { ...this.defaultSettings }
      this.$message({
        message: '设置已重置为默认值',
        type: 'info',
      })
    },
  },
}
</script>
<style lang="less" scoped>
.content {
  background-color: white;
  padding: 10px;
  line-height: 50px;
  font-size: 16px;
}
</style>
